import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

async function ObtenerUrlDescargaBackupService(values) {
    try {
        return await instance.Backend.post(
            "/Backup/ObtenerUrlDescarga",
            values,
            customConfig
        );
    } catch (error) {
        console.log(error);
    }
}

export { ObtenerUrlDescargaBackupService };
